import {
	big_win, fps,
	mega_win,
	round_running,
	server_config, states,
	super_win,
	wi
} from "../framework/src/engine/madnes/madnes_variables";
import {
	madnes_anim_add,
	madnes_anim_add_oncomplete_once,
	madnes_anim_play, madnes_anim_stop, madnes_show_money, madnes_stop_coin
} from "../framework/src/engine/madnes/madnes_anims";
import {
	madnes_get_alpha,
	madnes_get_cstm_val,
	madnes_get_pos_x,
	madnes_get_pos_y,
	madnes_get_scale_x,
	madnes_get_scale_y, madnes_get_visible,
	madnes_set_alpha,
	madnes_set_pos,
	madnes_set_pos_y,
	madnes_set_texture,
	madnes_set_visible,
	madnes_sprite_get_frame_name
} from "../framework/src/engine/madnes/madnes_object";
import {madnes_tween_func, madnes_tween_stop, madnes_tween_to} from "../framework/src/engine/madnes/madnes_tween";
import {bet, madnes_get_atomic_bet, madnes_money_to_coin} from "../framework/src/engine/madnes/madnes";
import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {
	madnes_audio_fade_to,
	madnes_audio_loop,
	madnes_audio_play,
	madnes_audio_stop
} from "../framework/src/engine/madnes/madnes_audio";
import {madnes_add_to_render, madnes_move_to, madnes_rem_from_render, madnes_scale_to, madnes_alpha_to} from "../framework/src/engine/madnes/madnes_render";
import {STATES} from "../framework/src/states/states";
import {show_bigwin_label} from "./j27_reels";

var money_add_big_win_anim_step = 0;
export function set_money_add_big_win_anim_step(val) {
	money_add_big_win_anim_step = val;
}


var money_add_big_win_add_to_render;
var moneyadd_pos = 0;
var money_add_big_win_callback = function() {};
export function set_money_add_big_win_callback(func) {
	money_add_big_win_callback = func;
}

export function money_add_big_win_anim(max, from_freespin)
{
	switch(money_add_big_win_anim_step)
	{
		case 0:

			setTimeout(function() {
				madnes_audio_play("YOU_WON");
			}, 160);

			if(from_freespin)
			{
				madnes_set_visible('bonuswin', true);
			}
			else
			{
				show_bigwin_label('bigwin_label');
				madnes_set_alpha('bigwin_bg', 0);
				madnes_set_visible('bigwin_bg', true);
				madnes_fade_in('bigwin_bg', 1000 / fps);
			}

			money_add_big_win_anim_step = 1;
			money_add_big_win_anim(max, from_freespin);
			break;
		case 1:
			money_add_big_win_add_pos = 0;
			money_add_big_win_add_max = max;
			money_add_big_win_add_step = -1;

			money_add_big_win_add_to_render = money_add_big_win_add.bind(this, from_freespin);
			madnes_add_to_render(money_add_big_win_add_to_render);
			break;
		case 2:


			money_add_big_win_anim_step = 3;

			windesk_hide();

			money_add_big_win_anim(max, from_freespin);

			break;
		case 3:

			money_add_big_win_anim_step = 0;

			money_add_big_win_callback();

			break;
	}
}

var money_add_big_win_add_pos = 0;
var money_add_big_win_add_max = 0;
var money_add_big_win_add_step = -1;
function money_add_big_win_add(from_freespin)
{
	/*var add = Math.floor(( (bet * big_win) / 100 ) * (Math.random() * 4));

	if(win_type == "FS_WIN_2")
	{
		add = Math.floor(( (bet * mega_win) / 100 ) * (Math.random() * 4));
	}
	if(win_type == "FS_WIN_3")
	{
		add = Math.floor(( win / 180 ) * (Math.random() * 4));
	}*/

	var tmp_add = Math.round( money_add_big_win_add_max * ( Math.random() / 100 ) );
	if(tmp_add < 1)
	{
		tmp_add = 1;
	}
	money_add_big_win_add_pos = money_add_big_win_add_pos * 1 + tmp_add;

	if(money_add_big_win_add_step == -1) {

		if(money_add_big_win_add_max >= 8000) {
			madnes_audio_loop('remittance_A');
		}

		money_add_big_win_add_step = 0;
	}

	if(money_add_big_win_add_step == 0 && money_add_big_win_add_pos > bet * mega_win && !from_freespin)
	{
		//money_add_big_win_add_pos = madnes_get_money_bet(bet) * mega_win;
		money_add_big_win_add_step = 1;

		show_bigwin_label('megawin_label');
	}
	else if(money_add_big_win_add_step == 1 && money_add_big_win_add_pos > bet * super_win)
	{
		//money_add_big_win_add_pos = madnes_get_money_bet(bet) * super_win;
		money_add_big_win_add_step = 2;

		show_bigwin_label('supermegawin_label');

	}

	if(money_add_big_win_add_pos > money_add_big_win_add_max)
	{


		madnes_audio_stop('remittance_A');
		madnes_audio_play("remittance_B");

		money_add_big_win_add_pos = money_add_big_win_add_max;

		madnes_rem_from_render(money_add_big_win_add_to_render);
		money_add_big_win_anim_step = 2;

		setTimeout(function() {
			madnes_stop_coin();
		}, money_add_big_win_add_max < 100 ? 2000 : 0);

		setTimeout(money_add_big_win_anim.bind(this, money_add_big_win_add_max, from_freespin), 3000);
	}

	windesk_setsum(money_add_big_win_add_pos, money_add_big_win_add_max < 8000);
}

var windesk_sum;
function windesk_setsum(sum, playRemmitance)
{
	var add = (sum | 0);

	if(playRemmitance && (windesk_sum !== add) && add > 0) {
		madnes_audio_play('remittance_A');
	}

	windesk_sum = add;

	madnes_set_visible('windesk_sum', true);
	madnes_set_text('windesk_sum', windesk_sum);
}

function windesk_hide()
{
	if(madnes_get_visible('bonuswin'))
	{
		madnes_fade_out('bonuswin', 600, 0, function() {
			madnes_set_alpha('bonuswin', 1);
			madnes_set_visible('bonuswin', false);
		});
	}
	else
	{
		madnes_fade_out('bigwin_bg', 600, 0, function() {
			madnes_set_alpha('bigwin_bg', 1);
			madnes_set_visible('bigwin_bg', false);
		});
	}

	madnes_fade_out('windesk_sum', 600, 0, function() {
		madnes_set_alpha('windesk_sum', 1);
		madnes_set_visible('windesk_sum', false);
	});
}

var freespin_state = new Array();

/**
 * @param {string} name
 * @param {number} duration
 * @param {number=} delay
 * @param {Function=} cb
 */
function madnes_fade_out(name, duration, delay, cb)
{
	if(delay == 'undefined' || !delay) {
		delay = 0;
	}

	setTimeout(madnes_alpha_to.bind(this, name, 0, duration, cb), delay);
}

/**
 * @param {string} name
 * @param {number} duration
 * @param {number=} delay
 * @param {Function=} cb
 */
function madnes_fade_in(name, duration, delay, cb)
{
	if(delay == 'undefined' || !delay) {
		delay = 0;
	}

	setTimeout(madnes_alpha_to.bind(this, name, 1, duration, cb), delay);
}

function madnes_anim_pulse(name, xScale, yScale, duration, delay, cb)
{

	var origScaleX = madnes_get_scale_x(name);
	var origScaleY = madnes_get_scale_y(name);

	setTimeout(madnes_scale_to.bind(this, name, xScale, yScale, duration), delay);
	setTimeout(madnes_scale_to.bind(this, name, origScaleX, origScaleY, duration), duration + delay, cb);
}

export function madnes_anim_scale(name, xScale, yScale, duration, delay, callback)
{
	setTimeout(madnes_scale_to.bind(this, name, xScale, yScale, duration, callback), delay);
}

function madnes_anim_blink(name, count, duration, callback)
{
	setTimeout(function() {

		madnes_set_visible(name, !madnes_get_visible(name));

		if(count >= 0) {
			madnes_anim_blink(name, --count, duration, callback);
		} else {
			if(typeof callback == 'function') {
				callback();
			}
		}
	}, duration);
}

export function freespin_hide() {
	madnes_set_visible("bonus_reels", false);
	madnes_set_visible("bonus_cover", false);
	madnes_set_visible("text_bonus_games_num", false);
	madnes_set_text("text_bonus_games_num", "0/0");

}

export function freespin_show() {
	madnes_set_visible("bonus_reels", true);
}

export function anims_money_add_win_anim(won)
{
	return new Promise(function (res) {
		madnes_show_money(madnes_money_to_coin(won), res);
	});
}